
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { LanguageSwitcher } from '../../../components/LanguageSwitcher';

export function Header() {
  const { t } = useTranslation('common');
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg' : 'bg-white/95 backdrop-blur-sm'
      }`}
    >
      <div className="container mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex-shrink-0">
            <img 
              src="https://static.readdy.ai/image/a19dd0a56f3d184158c62a348fccb582/f2eae84610da25ffff8cb3de975ca611.png" 
              alt="APL Consultoria" 
              className="h-14 w-auto cursor-pointer"
              onClick={() => scrollToSection('hero')}
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-8">
            <button 
              onClick={() => scrollToSection('hero')}
              className="text-gray-700 hover:text-orange-500 font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              {t('nav.home')}
            </button>
            <button 
              onClick={() => scrollToSection('servicos')}
              className="text-gray-700 hover:text-orange-500 font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              {t('nav.services')}
            </button>
            <button 
              onClick={() => scrollToSection('sobre')}
              className="text-gray-700 hover:text-orange-500 font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              {t('nav.about')}
            </button>
            <button 
              onClick={() => scrollToSection('historia')}
              className="text-gray-700 hover:text-orange-500 font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              {t('nav.history')}
            </button>
            <button 
              onClick={() => scrollToSection('contato')}
              className="px-6 py-2 bg-orange-500 text-white font-semibold rounded-lg hover:bg-orange-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              {t('nav.contact')}
            </button>
            <LanguageSwitcher />
          </nav>

          {/* Mobile Menu Button */}
          <div className="lg:hidden flex items-center gap-3">
            <LanguageSwitcher />
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="text-gray-700 hover:text-orange-500 transition-colors cursor-pointer"
              aria-label="Toggle menu"
            >
              <i className={`text-2xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <nav className="lg:hidden py-6 border-t border-gray-200">
            <div className="flex flex-col gap-4">
              <button 
                onClick={() => scrollToSection('hero')}
                className="text-gray-700 hover:text-orange-500 font-medium transition-colors text-left cursor-pointer whitespace-nowrap"
              >
                {t('nav.home')}
              </button>
              <button 
                onClick={() => scrollToSection('servicos')}
                className="text-gray-700 hover:text-orange-500 font-medium transition-colors text-left cursor-pointer whitespace-nowrap"
              >
                {t('nav.services')}
              </button>
              <button 
                onClick={() => scrollToSection('sobre')}
                className="text-gray-700 hover:text-orange-500 font-medium transition-colors text-left cursor-pointer whitespace-nowrap"
              >
                {t('nav.about')}
              </button>
              <button 
                onClick={() => scrollToSection('historia')}
                className="text-gray-700 hover:text-orange-500 font-medium transition-colors text-left cursor-pointer whitespace-nowrap"
              >
                {t('nav.history')}
              </button>
              <button 
                onClick={() => scrollToSection('contato')}
                className="px-6 py-2 bg-orange-500 text-white font-semibold rounded-lg hover:bg-orange-600 transition-colors text-left cursor-pointer whitespace-nowrap"
              >
                {t('nav.contact')}
              </button>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
}
